/**
 * 为了传入 this，不要写成箭头函数
 */
import {
  PublicRenders,
  defaultColRender,
  defaultPopoverHeaderRender,
  checkboxHeaderRender,
  shortTermFieldHeaderRender,
  longTermFieldHeaderRender
} from 'Src/pagelets/promotion/public-renders.js'
import { promotionDefaultCustomizeCols } from 'Src/const/state/statistics-fields-promotion.js'
import {
  ADD_GLOBAL_TYPE_SEARCH,
  GLOBAL_FILTERS_PARAMS_CHANGE,
  PAGE_SIZE_CHANGE,
  FILTERS_CHANGE,
  DATE_FILTER_CHANGE,
  SET_SELECTED_ROW_INDEX,
  AUTO_MATE_RULES_PARAM
} from '../../pages/promotion/store'
import { PromotionTypes } from 'Src/pagelets/promotion/promotion-state.js'
import { AllFilterKeys, AllFiltersConfig, NoLimitVal, PromotionFilterValue } from 'Src/components/promotion/all-filters-options.js'
import Apis from 'Src/const/apis'
import ApiUrl from 'Src/const/apis/promotion/index'
import Tool from 'Src/util/tool.js'
import { landingType, campaignType } from 'Src/const/state/campaign.js'
import { PromotionHeaderTips, SelectedTableRowClass } from 'Src/pagelets/promotion/promotion-state'
import url from 'Src/util/url'
import pipe from 'lodash/fp/pipe'
import map from 'lodash/fp/map'
import filter from 'lodash/fp/filter'
import isNil from 'lodash/fp/isNil'
import { imageModeConfig } from 'Src/const/state/statistics-fields'
import * as CampaignState from 'Src/const/state/campaign'

// bugfix:特殊场景下 th有缓存，width和UI层显示不一致
export const hasTableWidthMatch = function () {
  let thList = document.getElementsByTagName('th')
  try {
    thList = Array.from(thList)
    const flag = thList.some(item => {
      if (item.id) {
        return item.children && item.children[0].offsetWidth !== item.offsetWidth
      }
      return false
    })
    if (flag) {
      document.documentElement.scrollTop += 1
      document.documentElement.scrollTop -= 1
    }
  } catch (error) {
  }
}
// 指定列 表头非4字折行
const notModifyColumns = ['web_url', 'ecpm', 'attribution_convert_cost', 'attribution_deep_convert_cnt', 'attribution_deep_convert_cost', 'delivery', 'deep_external_action_cost', 'attribution_convert_cnt', 'phone', 'phone_confirm', 'phone_connect', 'click_call', 'click_call_cnt', 'click_counsel', 'form_click_button', 'click_shopwindow', 'click_website', 'click_download', 'click_call_dy']
// 拖拽后将列的信息保存在locastorage中
export const setResizeColumns2Storage = function (columns) {
  let resizeColumns = JSON.parse(window.localStorage.getItem('promotion_resize_columns')) || []

  columns.forEach(column => {
    const findex = resizeColumns.findIndex(item => {
      if ((item.key && item.key === column.key) || (item.type && item.type === column.type)) {
        if ((column.children && column.children[0].width) || (!column.children && column.width)) {
          return true
        }
      }
      return false
    })
    if (findex > -1) {
      resizeColumns[findex] = column
    } else if ((column.children && column.children[0].width) || (!column.children && column.width)) {
      resizeColumns.push(column)
    }
  })
  window.localStorage.setItem('promotion_resize_columns', JSON.stringify(resizeColumns))
}

export const mapColumns = function (columns, customizedColumnKeys, sort, configuredColumns) {
  const vm = this

  // 1. 配置自定义列
  const customizedColumns = []

  // 拖拽列宽保存变量
  const resizeColumns = JSON.parse(window.localStorage.getItem('promotion_resize_columns')) || [] // vm.resizeColumns || []

  const BasicColumnMinWidth = 70 // 默认列固定宽度
  const SortableColumnMinWidth = 82 // 可排序列固定宽度
  const GuiyinColumnMinWidth = 140 // 归因列的固定宽度
  const FontSize = 12

  // const allCols = [...Object.values(promotionAttributesColumns), ...configuredColumns]
  configuredColumns.forEach(group => {
    group.options.forEach(col => {
      const column = { ...col } // 避免 mutation
      if (customizedColumnKeys.includes(column.name) && !this.guiyinObjectInfo[column.name]) {
        const name = column.name
        let colAlign = 'right'
        let colSortable = true
        let colMinWidth
        let vmRender
        const guiyinColumn = this.guiyinObjectAllList[name]
        const resizeColumnIndex = resizeColumns.findIndex(item => {
          if (item.key && column.name) {
            return item.key === column.name
          }
          return false
        })
        const childResizeColumn = {}

        // 拖拽后列宽
        if (resizeColumnIndex > -1) {
          if (resizeColumns[resizeColumnIndex].width) column.width = resizeColumns[resizeColumnIndex].width
          if (resizeColumns[resizeColumnIndex].children &&
            resizeColumns[resizeColumnIndex].children.length &&
            resizeColumns[resizeColumnIndex].children[0].width) {
            childResizeColumn.width = resizeColumns[resizeColumnIndex].children[0].width
          }
        }
        // 自定义列的自定义配置
        const curCustomizedColConf = promotionDefaultCustomizeCols[name]
        if (curCustomizedColConf) {
          if (curCustomizedColConf.align) {
            colAlign = curCustomizedColConf.align
          }
          if (curCustomizedColConf.sortable !== undefined) {
            colSortable = curCustomizedColConf.sortable
          }
          if (curCustomizedColConf.minWidth) {
            colMinWidth = curCustomizedColConf.minWidth
          }
          if (curCustomizedColConf.render) {
            vmRender = vm[curCustomizedColConf.render]

            // 如果有 PublicRenders ，优先取 PublicRenders
            if (PublicRenders[curCustomizedColConf.render]) {
              vmRender = PublicRenders[curCustomizedColConf.render].bind(vm)
            }
          }
          if (curCustomizedColConf.charWidth) {
            // 该列字符宽度，用于在 render 中设置 context.column.minWidth
            column.charWidth = curCustomizedColConf.charWidth
          }
        }

        column.sortType = undefined // 还原排序状态
        if (sort && sort.key && sort.order && column.name === sort.key) {
          column.sortType = sort.order
        }
        column.key = name
        column.title = (column.label ? column.label : '--')
        column.align = colAlign
        column.sortable = colSortable
        column.minWidth = column.sortable ? SortableColumnMinWidth : BasicColumnMinWidth // 默认表头超过4个字折行
        // 指定列 表头超过5个字折行
        if (notModifyColumns.some(key => key === name)) {
          column.minWidth = column.minWidth + FontSize
        }

        // 如果有 自定义的最小宽度，应用之
        if (colMinWidth) {
          column.minWidth = colMinWidth
        }
        let sumTitle = this.table.statistics ? this.table.statistics[column.key] : ''
        const unit = column.unit && column.unit !== $bp_t('元', 'common.element') ? column.unit : ''
        column.renderHeader = defaultPopoverHeaderRender.bind(this)
        column.children = [{
          title: sumTitle, // title为总计行数据
          key: column.key,
          align: colAlign,
          minWidth: guiyinColumn ? GuiyinColumnMinWidth : column.minWidth, // 归因即时影响指标使用固定最小宽度
          sortable: false,
          unit: unit,
          ...childResizeColumn,
          renderHeader (h, { column, index }) {
            return (<div class='default-header-wrapper'><div class='table-header multiple-line-txt-cut'>{column.title}{unit}</div></div>)
          },
          render (h, { column, index }) {
            if (vmRender) {
              column.render = vmRender
            } else {
              // 默认使用 defaultColRender 渲染自定义列
              column.render = defaultColRender.bind(vm)
            }
          }
        }]

        const isSelectedGuiyinMetric = (guiyinMetric) => customizedColumnKeys.includes(guiyinMetric.name)

        const isValidGuiyinField = (guiyinColumn) => {
          if (!isNil(guiyinColumn)) {
            // 如果没有支持的长效指标时长被选中，就不做特殊处理
            return guiyinColumn?.indirect_click?.metrics?.some(isSelectedGuiyinMetric)
          }
          return false
        }

        if (isValidGuiyinField(guiyinColumn)) { // 归因即时指标
          column.renderHeader = shortTermFieldHeaderRender.bind(this) // 用特殊的表头renderer覆盖
        }
        customizedColumns.push(column)

        // 如果是归因指标，在即时影响指标后面加入不同时长的长效影响指标，聚合在同一表头下
        if (isValidGuiyinField(guiyinColumn)) {
          const longTermChildFactory = (metricsLength) => (guiyinField) => {
            return {
              title: this.table.statistics
                ? this.table.statistics[guiyinField.name]
                : '', // title为总计行数据
              key: guiyinField.name,
              align: colAlign,
              minWidth:
                metricsLength > 1 ? BasicColumnMinWidth : GuiyinColumnMinWidth, // 多个长效指标单元格合并时使用小宽度
              sortable: false,
              unit: unit,
              guiyinType: guiyinField.type,
              ...childResizeColumn,
              renderHeader (h, { column, index }) {
                return (
                  <div class="default-header-wrapper">
                    <div class="table-header multiple-line-txt-cut">
                      {column.title}
                      {unit}
                    </div>
                  </div>
                )
              },
              render: PublicRenders.publicRenderGuiyin
            }
          }

          const mapGuiyinFieldToRenderChild = pipe(
            filter(isSelectedGuiyinMetric),
            (metrics) => map(longTermChildFactory(metrics.length))(metrics)
          )

          customizedColumns.push({
            ...column,
            key: name + '_guiyin',
            sortable: false,
            renderHeader: longTermFieldHeaderRender.bind(this),
            children: mapGuiyinFieldToRenderChild(
              guiyinColumn?.indirect_click?.metrics ?? []
            )
          })
        }
      }
    })
  })

  // 2. 按照自定义列的顺序排序
  customizedColumns.sort((a, b) => {
    const aIndex = customizedColumnKeys.indexOf(a.name)
    const bIndex = customizedColumnKeys.indexOf(b.name)

    return aIndex - bIndex
  })

  const fixedCols = columns.map(column => {
    // 拖拽后宽度回填
    const resizeColumnIndex = resizeColumns.findIndex(item => {
      if (item.key) {
        return item.key === column.key
      }
      if (item.type) {
        return item.type === column.type
      }
      return false
    })
    const childResizeColumn = {}

    // 拖拽后列宽
    if (resizeColumnIndex > -1) {
      if (resizeColumns[resizeColumnIndex].width) column.width = resizeColumns[resizeColumnIndex].width
      if (resizeColumns[resizeColumnIndex].children &&
        resizeColumns[resizeColumnIndex].children.length &&
        resizeColumns[resizeColumnIndex].children[0].width) {
        childResizeColumn.width = resizeColumns[resizeColumnIndex].children[0].width
      }
    }
    column.sortable = !column.nosort
    if (!column.align) {
      column.align = 'right'
    }
    // 有 type 表示使用 BUI table 默认的 selection，没有 type 表示使用自定义的 selection 的render 函数
    // 这里计划下需要使用自定义的 render
    const selectionCol = column.type === 'selection' || column.key === 'selection'
    const useSelectionInsideTable = column.type === 'selection'
    const useSelectionCustom = column.key === 'selection'
    if (!selectionCol) {
      column.renderHeader = defaultPopoverHeaderRender.bind(this)
    }
    // 计划下的 selection 列需要自定义
    if (useSelectionCustom) {
      column.renderHeader = checkboxHeaderRender.bind(this)
    }
    let vmRender
    if (column.render && vm[column.render]) {
      vmRender = vm[column.render]
    }
    column.children = [{
      title: '',
      key: column.key,
      align: column.align,
      fixed: column.fixed,
      width: column.width,
      minWidth: column.minWidth,
      sortable: false,
      type: useSelectionInsideTable ? 'selection' : '',
      ...childResizeColumn
    }]
    // table fix 列， 未使用 table 内置的 selection，就需要使用 render
    if (!useSelectionInsideTable) {
      column.children[0].render = vmRender
      column.children[0].renderHeader = (h, { column, index }) => {
        // 专门处理总计行
        if (['ad_name', 'creative_id', 'campaign_name', 'word'].indexOf(column.key) > -1) {
          return <div class='default-header-wrapper'><div class='table-header multiple-line-txt-cut'>{ $bp_t(`总计（共${this.pagination.totalNum}项）`, 'common.total_RMB', { data: this.pagination.totalNum })}</div></div>
        }
      }
    }
    return column
  })

  // 3. 将 固定列 和 所有自定义列合并返回
  return fixedCols
    .concat(customizedColumns)
}

export const SwitchVal = {
  enable: 0,
  disable: 1,
  frozen: 2
}
export const StatusOperation = {
  enable: 'enable',
  disable: 'disable',
  delete: 'delete',
  frozen: 'frozen'
}
export const getSwitchCheckedVal = function (status) {
  return (status === SwitchVal.enable)
}

export const resetTableScroll = function () {
  // 表格已经向左滚动的情况下，更新数据（例如排序）后，表头、表体因宽度不同会错位，故需重置整个表格的scrollLeft为0。
  setTimeout(() => {
    const buiTableHeaderEl = document.querySelector('.bui-table-header')
    if (buiTableHeaderEl) {
      buiTableHeaderEl.scrollLeft = 0
    }
    const buiTableBodyEl = document.querySelector('.bui-table-body')
    if (buiTableBodyEl) {
      buiTableBodyEl.scrollLeft = 0
    }
    const customScrollEl = document.querySelector('.custom-scroll-content')
    if (customScrollEl) {
      customScrollEl.scrollLeft = 0
    }
  }, 0)
}

// 通过文本内容判断指定宽高情况下，文本是否会溢出。
export const getMultipleLineTextIsEllipsis = function (text, maxHeight = 36, widthPadding = 42) {
  // 36px === 18*2，两行的高度
  if (text === undefined || text === '') {
    return
  }

  let cellNameEl = document.querySelector('.bui-table-body .bui-table-tr .bui-table-column:nth-child(3)')
  let cellNameWidth
  if (cellNameEl) {
    cellNameWidth = parseInt(window.getComputedStyle(cellNameEl).width)
  } else {
    // 如果没有得到名称单元格的宽度，仍视为文本溢出作为兜底（该逻辑已经和PM确认过）
    return true
  }

  const elId = 'test-text-ellipsis'
  let el = document.getElementById(elId)
  if (!el) {
    el = document.createElement('div')
    el.id = elId
    el.style.visibility = 'none'
    el.style.position = 'absolute'
    el.style.left = '-999em'
    el.style.fontSize = '12px'
    el.style.lineHeight = '18px'
    el.style.wordBreak = 'break-all'

    document.body.appendChild(el)
  }

  el.innerText = text
  el.style.width = (cellNameWidth - widthPadding) + 'px'
  let noEllipsisElHeight = parseInt(window.getComputedStyle(el).height)

  return (noEllipsisElHeight > maxHeight)
}

export const promotionPrefix = '_promotion'
export const promotionPageSizeKey = 'pageSize'

export const setLocalStorageParam = function (key, val) {
  window.localStorage.setItem(promotionPrefix + key, val)
}

export const setParamFromLocalStorage = function () {
  const curPageSize = window.localStorage.getItem(promotionPrefix + promotionPageSizeKey)
  if (curPageSize) {
    this.$store.commit(PAGE_SIZE_CHANGE, curPageSize)
  }
}

const addGlobalSearchFilter = function (type, term, queryType) {
  this.$store.commit(ADD_GLOBAL_TYPE_SEARCH, [{
    typeVal: type,
    // typeName: name,
    searchTerm: term
  }])
  this.$store.commit(GLOBAL_FILTERS_PARAMS_CHANGE, {
    search_type: type,
    keyword: term,
    query_type: queryType
  })
}

export const addCampaignGlobalIdFilter = function (campaignIdStr) {
  const type = PromotionTypes.campaign.value
  addGlobalSearchFilter.call(this, type, campaignIdStr)
}

export const addAdIdGlobalFilter = function (adIdStr) {
  const type = PromotionTypes.ad.value
  addGlobalSearchFilter.call(this, type, adIdStr)
}

export const writeQueryParams = function (key, value) {
  let curQuery = JSON.parse(JSON.stringify(this.$route.query))

  curQuery[key] = value

  this.$router.push({
    query: curQuery
  })
}

// 将推广管理四个 tab 改为异步组件后，在 router-view 外部读取 this.$route 在初始化时读取到的数据为空，
// 需要等到 tab 组件挂载完成后才能读取，修改为直接读 location 中的值，不从 this.$route 中读

export const getCurTabName = function () {
  const hash = window.location.hash || ''
  const result = hash.match(/#\/(\w+)/)
  return (result && result[1]) || 'ad'
}
/**
 * pages/promotion.html?aadvid=637347912220931#/ad?local_campaign_id=1680325105850413&landing_type=8
 * vue-router 操作的 query 是 #/ad? 之后的，该方法用于读取该部分query
 */
export const getCurQuery = function () {
  const hash = decodeURIComponent(window.location.hash || '')
  const questionMark = hash.indexOf('?')
  if (questionMark === -1) {
    return {}
  }
  const queryString = hash.slice(questionMark + 1)
  const queryArr = queryString.split('&')
  return queryArr.reduce((pre, cur) => {
    const split = cur.split('=')
    pre[split[0]] = split[1]
    return pre
  }, {})
}

/**
 * 获取 path，跟 vue-router 中的 this.$route.path 一致
 */
export const getCurPath = function () {
  let hash = window.location.hash || ''
  const questionMark = hash.indexOf('?')
  if (questionMark > -1) {
    return hash.slice(1, questionMark)
  } else {
    return hash.slice(1)
  }
}

export const QueryFilterParamPrefix = 'filter_'

export const SearchQueryKey = {
  type: QueryFilterParamPrefix + 'search_type',
  keyword: QueryFilterParamPrefix + 'search_keyword',
  queryType: QueryFilterParamPrefix + 'query_type'
}

export const DrawerQueryKey = {
  nav: 'drawer_nav',
  secondNav: 'drawer_second_nav',
  id: 'drawer_target_id',
  group: 'drawer_group',
  protectStatus: 'drawer_protect_status',
  campaignId: 'drawer_campaign_id',
  purchaseType: 'drawer_purchase_type',
  campaignDedicateType: 'dedicate_type',
  localCampaignType: 'local_campaign_type',
  localGroupId: 'local_ad_group_id',
  localStep: 'local_step',
  localLandingType: 'local_landing_type'
}

export const DateQueryKey = {
  startTime: 'st',
  endTime: 'et'
}

export const NotificationQueryKey = {
  id: 'notification_id'
}

export const deleteDrawerQueryParams = function () {
  const query = JSON.parse(JSON.stringify(this.$route.query))

  const keyList = Object.values(DrawerQueryKey)

  keyList.forEach(item => {
    delete query[item]
  })

  this.$router.push({ query })
}

export const checkQueryFilters = function (query) {
  if (!query) {
    return
  }
  const autoFilter = []
  const curTabName = this.$route.name || getCurTabName()
  // 处理全局参数
  Object.keys(query).forEach(queryKey => {
    const prefixKey = queryKey
    queryKey = queryKey.substring(QueryFilterParamPrefix.length)
    if (queryKey === '') {
      return
    }

    // 处理切换TAB时的重复赋值问题
    const curGlobalParams = this.$store.state.URLFilters
    const keyHasAdded = curGlobalParams.some(item => {
      return (item.key === queryKey)
    })
    if (keyHasAdded) {
      return
    }

    if (AllFilterKeys.indexOf(queryKey) !== -1) {
      let value
      try {
        value = JSON.parse(query[prefixKey])
      } catch (err) {
        return
      }

      // 回显筛选项
      const filter = {
        ...AllFiltersConfig[queryKey],
        key: queryKey,
        multiple: AllFiltersConfig[queryKey].multiple
      }
      if (value?.automateRule) {
        filter.value = value.value
        filter.automateRule = true
        if (AllFiltersConfig[queryKey].parentType === curTabName) {
          autoFilter.push({
            lower: value.value.lower,
            upper: value.value.upper,
            field: filter.submitKey
          })
        }
      } else {
        let paramsValue = value
        // 将 query 参数中的值直接作为筛选项的选项
        if (filter.valueAsOptions) {
          const options = value.map(val => {
            val = Array.isArray(val) ? val[0] : val
            return {
              label: String(val),
              value: val
            }
          })
          filter.options = options
          AllFiltersConfig[queryKey].options = options
        }
        filter.selected = value
        if (filter.multiple) {
          // 多选时处理为一维数组，以便向后端接口传参
          paramsValue = []
          value.forEach(arr => {
            paramsValue = paramsValue.concat(arr)
          })
        }
        if (value.indexOf && (value.indexOf(NoLimitVal) !== -1)) {
          // 选项包含不限（已删除），按后端逻辑处理为不加筛选字段。
          // TODO 后续如果此处逻辑有改动，务必推动后端修改接口逻辑：不限也作为一个参数值传递，否则太坑了。
          paramsValue = []
        }
        if (!filter.displayOnly) {
          // 修改 globalParams，用于接口请求的数据
          this.$store.commit(GLOBAL_FILTERS_PARAMS_CHANGE, {
            [queryKey]: paramsValue
          })
        }
      }
      // 用于记录当前有哪些筛选项，用于 filter-panel 全局筛选组件进行数据回显
      this.$store.commit(FILTERS_CHANGE, filter)
    }
  })
  if (autoFilter.length) {
    this.$store.commit(GLOBAL_FILTERS_PARAMS_CHANGE, {
      [AUTO_MATE_RULES_PARAM]: autoFilter
    })
  }
  // 自动规则通知跳转中的消息ID
  if (query[NotificationQueryKey.id]) {
    this.$store.commit(GLOBAL_FILTERS_PARAMS_CHANGE, {
      [NotificationQueryKey.id]: +query[NotificationQueryKey.id]
    })
  }
  // 处理打开侧弹参数
  if (query[DrawerQueryKey.id] && query[DrawerQueryKey.nav]) {
    const nav = query[DrawerQueryKey.nav]
    const value = JSON.parse(query[DrawerQueryKey.id])
    const secondNav = query[DrawerQueryKey.secondNav] ? query[DrawerQueryKey.secondNav] : ''
    const isGroup = ~~(query[DrawerQueryKey.group] || 1)
    const protectStatus = ~~(query[DrawerQueryKey.protectStatus] || 0)
    const campaignId = query[DrawerQueryKey.campaignId]
    const purchaseType = query[DrawerQueryKey.purchaseType]
    const campaignDedicateType = +query[DrawerQueryKey.campaignDedicateType]
    if (this.initDrawer) {
      this.initDrawer(nav, value, undefined, secondNav, isGroup, protectStatus, campaignId, purchaseType, campaignDedicateType)
    }
  }

  // 处理搜索参数
  if (query[SearchQueryKey.type] && query[SearchQueryKey.keyword]) {
    addGlobalSearchFilter.call(this, query[SearchQueryKey.type], query[SearchQueryKey.keyword], query[SearchQueryKey.queryType])
  }

  // 处理时间范围参数
  if (query[DateQueryKey.startTime] && query[DateQueryKey.endTime]) {
    this.$store.commit(DATE_FILTER_CHANGE, {
      start: query[DateQueryKey.startTime],
      end: query[DateQueryKey.endTime]
    })
  }
}

export const getIsUsingNewPromotion = function () {
  // 不在抖音link白名单内
  let usePromotionNewVersion = !Tool.isSupported(GLOBAL_VAR.isSupportLinkAd)
  const UserIsUsingNewPromotion = window.localStorage.usePromotionNewVersion === 'true'

  return (usePromotionNewVersion && UserIsUsingNewPromotion)
}

const NewOldQueryKeyMap = {
  [PromotionFilterValue.AdStatus._key]: 'ad_status'
}

const QueryParamMap = {
  ad_status: {
    delivering: {
      old: [NewOldQueryKeyMap[PromotionFilterValue.AdStatus._key], 'delivery_ok'],
      new: [PromotionFilterValue.AdStatus._key, [PromotionFilterValue.AdStatus.delivering]]
    },
    reject: {
      old: [NewOldQueryKeyMap[PromotionFilterValue.AdStatus._key], 'offline_audit'],
      new: [PromotionFilterValue.AdStatus._key, [PromotionFilterValue.AdStatus.auditReject]]
    },
    noBudget: {
      old: [NewOldQueryKeyMap[PromotionFilterValue.AdStatus._key], 'offline_budget'],
      new: [PromotionFilterValue.AdStatus._key, [PromotionFilterValue.AdStatus.noBudget]]
    }
  }
}

const getQueryParam = function (key, value, isNew) {
  if (!key || !value || isNew === undefined) {
    return
  }

  let ret = false

  if (QueryParamMap && QueryParamMap[key] && QueryParamMap[key][value]) {
    let curQueryParamMap = QueryParamMap[key][value]
    curQueryParamMap = isNew ? curQueryParamMap.new : curQueryParamMap.old
    let [paramKey, paramValue] = curQueryParamMap

    if (paramValue instanceof Array) {
      paramValue = JSON.stringify(paramValue)
    }
    ret = {
      [paramKey]: paramValue
    }
  }

  return ret
}

// const QueryObj = {
//   queryKey: 'ad_status',
//   queryValue: 'delivering',
//   target: '', // 'campaign' || 'ad' || 'creative'
//   st: '',
//   et: ''
// }

// 获取跳转到推广的URL，兼容新旧版、查询参数映射，支持部分参数（QueryParamMap）
export const getPromotionURL = function (query) {
  if (!query || !query.target) {
    return Apis.promotion.newURL.ad
  }

  const isUsingNewPromotion = getIsUsingNewPromotion()
  const baseURL = (isUsingNewPromotion ? Apis.promotion.newURL : Apis.promotion.oldURL)
  let targetURL
  if (query.target) {
    targetURL = baseURL[query.target]
  }

  let searchStr = ''
  const QueryParam = getQueryParam(query.queryKey, query.queryValue, isUsingNewPromotion)
  if (QueryParam) {
    // searchStr = new URLSearchParams(QueryParam).toString()
    searchStr = Tool.jsonToQuery(QueryParam)
  }

  if (query.st && query.et) {
    const st = query.st
    const et = query.et
    searchStr += (!searchStr ? '?' : '&')
    searchStr += `st=${st}&et=${et}`
  }

  return url.updateQueryWithAdvid(targetURL + searchStr)
}

export const postNewBudget = function (newBudget, adID, successCallback) {
  const data = {
    ad_id: adID,
    budget: newBudget
  }
  const url = ApiUrl.promote.ad.adUpdateBudget
  BUI.update({
    // url: 'https://mock.bytedance.net/mock/5d08e32467d0ef01ffdefce9/promotion/success',
    url,
    data,
    success: (resp) => {
      if (!resp || (resp.status !== 'success' && resp.code !== 0)) {
        this.$message(resp.msg || $bp_t('更新广告计划预算失败，内部错误，请重试或联系管理员', 'bp.promotion_failed_to_update_advertising'), 'error')
        return
      }

      this.$message(resp.msg || $bp_t('更新广告计划预算成功', 'common.successfully_updated_advertising_plan_budget'), 'success')
      if (successCallback) {
        successCallback()
      }
    },
    error: (err) => {
      this.$message(err || $bp_t('更新广告计划预算失败，内部错误，请重试或联系管理员', 'bp.promotion_failed_to_update_advertising') + err.status, 'error')
    }
  })
}

export const postNewBid = function (newBid, adID, successCallback) {
  const data = {
    ad_id: adID,
    bid: newBid
  }
  const url = ApiUrl.promote.ad.adUpdateBid
  BUI.update({
    // url: 'https://mock.bytedance.net/mock/5d08e32467d0ef01ffdefce9/promotion/success',
    url,
    data,
    success: (resp) => {
      if (!resp || (resp.status !== 'success' && resp.code !== 0)) {
        this.$message(resp.msg || $bp_t('更新广告计划出价失败，请重试', 'bp.promotion_failed_to_update_ad_plan_bid_please_try_again'), 'error')
        return
      }
      this.$message($bp_t('更新广告计划出价成功', 'bp.promotion_update_ad_plan_bid_successful'), 'success')
      if (successCallback) {
        successCallback()
      }
    },
    error: (err) => {
      this.$message($bp_t('更新广告计划出价失败，请重试', 'bp.promotion_failed_to_update_ad_plan_bid_please_try_again') + err.status, 'error')
    }
  })
}

export const postDiagnosisFeedback = function (adName, adId, timeStamp, type, extra) {
  // 计划诊断埋点需求：https://bytedance.feishu.cn/space/doc/doccnsE1ZWK7MPormLC9zhIxaMh#
  // 计划诊断埋点接口文档：https://wiki.bytedance.net/pages/viewpage.action?pageId=235603555
  let data = {
    attribution_name: adName,
    attribution: {
      adid: adId,
      advid: GLOBAL_VAR.advertiser.id,
      diagnosis_ts: timeStamp
    },
    suggestion: ''
  }

  data.type = 'promotion_' + type
  if (extra) {
    data.attribution.extra = extra
  }

  data.attribution = JSON.stringify(data.attribution)

  BUI.update({
    type: 'POST',
    url: Apis.diagnosis.feedback,
    data,
    error: (err) => {
      if (Vue && Vue.prototype.$message) {
        Vue.prototype.$message($bp_t('计划诊断埋点接口网络错误', 'bp.promotion_plan_to_diagnose_buried_point_interface_network_error') + err.status, 'error')
      }
    }
  })
}

export const getStoreModifyStatus = function (status, curLandingType) {
  if ((parseInt(curLandingType) === landingType.ADVERTISER_STORE.value) && (status === $bp_t('不可编辑', 'bp.promotion_non_editable' || status === '不可编辑'))) {
    return PromotionHeaderTips.ladingTypeStoreVersion2
  }
}

export const setCurEditingRowWhenShowRightDrawer = function (type) {
  // 如果默认展示右侧详情页根据路径id来获取对应的行数据
  const idType = type === 'campaignIds' ? 'campaign_id' : 'ad_id'
  if (this.$store.state.isShowRightDrawer && this.drawerInitInfo[type] && this.tempTableData.row) {
    const row = this.tempTableData.row.filter(item => item[idType] === this.drawerInitInfo[type][0])
    if (row.length > 0) this.curEditingRow = row[0]
  }
}

export const tableTurboConf = {
  mode: 'div',
  rowHeight: '48px',
  headerHeight: '48px'
}

export const getProceduralCreativeInfo = function (creative) {
  let retArr = []
  const materialList = creative.image_list

  if (materialList && materialList.length) {
    materialList.some(info => {
      if (info.image_info && info.image_info.length) {
        if (info.video_info) {
          // 一个素材，既有图，又有视频，则图是视频的封面
          const videoInfo = info.video_info
          videoInfo.posterImageInfo = info.image_info[0]
          retArr.push(videoInfo)
        } else {
          retArr.push(info.image_info[0])
        }
      }
      if (retArr.length >= 4) {
        return true
      }
    })
  }
  const coupons = creative.coupon_list?.map(item => {
    return Object.assign({
      image_mode: imageModeConfig.DECORATION_LEAGUE_COUPON.value
    }, item)
  }) || []
  retArr.push(...coupons)

  return retArr
}
export const getAbCreativeInfo = function (creative) {
  let retArr = []
  const materialList = creative.image_list

  if (materialList && materialList.length) {
    materialList.some(info => {
      if (info.image_info && info.image_info.length) {
        const imageInfo = info.image_info[0]
        if (info.video_info) {
          imageInfo.video_id = info.video_info?.video_id
        }
        retArr.push(imageInfo)
      }
    })
  }
  return retArr
}
export const getProceduralCreativeTitle = function (creative) {
  let titlePartArr = []
  if (creative.image_list && creative.image_list.length) {
    let imageNum = 0
    let videoNum = 0
    creative.image_list.forEach(creative => {
      if (creative.image_info) {
        if (creative.video_info && creative.video_info.video_id) {
          videoNum++
        } else {
          imageNum++
        }
      }
    })
    if (videoNum) {
      titlePartArr.push($bp_t(`${videoNum}个视频`, 'common.vedio_number', { data: videoNum }))
    }
    if (imageNum) {
      titlePartArr.push($bp_t(`${imageNum}个图片`, 'common.picture_number', { data: imageNum }))
    }
  }
  if (creative.coupon_list?.length) {
    titlePartArr.push(`${creative.coupon_list.length}个家装联盟卡券`)
  }
  if (creative.title_list && creative.title_list.length) {
    titlePartArr.push($bp_t(`${creative.title_list.length}个标题`, 'common.title_number', { data: creative.title_list.length }))
  }
  return titlePartArr.join('、')
}

export const clearActiveSelectedRows = function (oldIndex) {
  if (this.$refs &&
    this.$refs.bytedTable &&
    this.$refs.bytedTable.rebuildData &&
    oldIndex !== undefined) {
    const tableData = this.$refs.bytedTable.rebuildData[oldIndex]
    if (tableData.rowClassName) {
      delete tableData.rowClassName
    }

    this.$refs.bytedTable && this.$refs.bytedTable.tableResize() // 触发更新样式
  }
}

export const activeSelectedRow = function (context) {
  if (context) {
    if (context.row !== undefined) {
      context.row.rowClassName = SelectedTableRowClass
    }
    if (this.$store && context.index !== undefined) {
      this.$store.commit(SET_SELECTED_ROW_INDEX, context.index)
    }
  }
}

export const resetCustomScroll = function (currentScrollLeft) {
  let num = 0
  let timer = setInterval(() => {
    if (num > 50) {
      clearInterval(timer)
    }
    if ($('.promotion-card .custom-scroll-content') && $('.promotion-card .bui-table-header')) {
      $('.promotion-card .custom-scroll-content').animate({ scrollLeft: currentScrollLeft }, 0)
      $('.promotion-card .bui-table-header').animate({ scrollLeft: currentScrollLeft }, 0)
      clearInterval(timer)
    }
    num++
  }, 50)
}

export const recordColumnResizeTeaEvent = function (columnKey, width) {
  const unknown = 'unknown'
  window.teaEvent('promotion_column_resize', {
    advID: (GLOBAL_VAR && GLOBAL_VAR.advertiser && GLOBAL_VAR.advertiser.id) || unknown,
    columnKey: columnKey || unknown,
    width: width || unknown
  })
}

export const getShowSuggestion = function (row) {
  const AuditRejectStatusName = '审核不通过'
  const AuditRejectStatusNameI18n = $bp_t('审核不通过', 'common.ad_status_41')
  const PartlyDeliveryStatusName = '部分投放中' // 目前新版暂时没有部分投放中状态
  const PartlyDeliveryStatusNameI18n = $bp_t('部分投放中', 'common.ad_status_63') // 目前新版暂时没有部分投放中状态

  // 审核拒绝理由展示条件 is_hint_reject_reason = 1 或 状态为 审核不通过/部分投放中
  const status = row.ad_status_name || row.creative_status_name || row.search_keyword_status_name
  const isSuggestionStatus = [AuditRejectStatusName, AuditRejectStatusNameI18n, PartlyDeliveryStatusName, PartlyDeliveryStatusNameI18n].includes(status)

  return isSuggestionStatus || !!row.is_hint_reject_reason
}

export const separateCampaignOrAdByType = (arr) => {
  const searchRows = []
  const feedRows = []
  const SEARCH_AD = campaignType.SEARCH_AD.value
  for (let row of arr) {
    if (!row) continue

    // 搜索广告省心投放需要过滤
    if (row.campaign_type === SEARCH_AD) searchRows.push(row)
    else feedRows.push(row)
  }
  return {
    searchRows,
    feedRows
  }
}
// 列表操作是否支持，目前RF广告很多操作收敛权限（RF附身且在白名单,其余可操作）
export const getOperationIsSupported = function (vm) {
  let surpported = true
  if (vm.isRF && (GLOBAL_VAR.sales !== 'true' || !Tool.isSupported(GLOBAL_VAR.adver_func.show_rf_report))) {
    surpported = false
  }
  return surpported
}
// 列表操作是否支持，目前RF广告很多操作收敛权限（RF附身且在白名单,其余可操作）
export const getOperationIsSupportedWithoutSales = function (vm) {
  let surpported = true
  if (vm.isRF && (!Tool.isSupported(GLOBAL_VAR.adver_func.show_rf_report))) {
    surpported = false
  }
  return surpported
}

const ORIGIN_FROM = 'diagnosis_origin_from'
const ORIGIN_FROM_ENUM = ['auto_rule']
const AUTORULE_IDS = 'filter_autorule_ids'
const AUTORULE_ID = 'autorule_id'

// 将自动规则来源的参数存入 sessionStorage，由诊断前端获取后加入埋点中
export function setDiagnosisToSession () {
  try {
    const query = JSON.parse(JSON.stringify(this.$route.query))
    const diagnosisOriginFrom = query[ORIGIN_FROM]

    if (ORIGIN_FROM_ENUM.includes(diagnosisOriginFrom)) {
      window.sessionStorage.setItem(ORIGIN_FROM, diagnosisOriginFrom)

      const autoruleIds = JSON.parse(query[AUTORULE_IDS])
      const autoruleId = autoruleIds[0][0]

      if (autoruleId) {
        window.sessionStorage.setItem(AUTORULE_ID, autoruleId)
      }
    } else {
      deleteDiagnosisFromSession(query)
    }
  } catch (error) {}
}

// 失去自动规则来源的参数时，从 sessionStorage 中删除参数
export function deleteDiagnosisFromSession (query) {
  try {
    const diagnosisOriginFrom = query[ORIGIN_FROM]

    if (!ORIGIN_FROM_ENUM.includes(diagnosisOriginFrom)) {
      window.sessionStorage.removeItem(ORIGIN_FROM)
      window.sessionStorage.removeItem(AUTORULE_ID)
    }
  } catch (error) {}
}
// 判断是否为ab实验计划
export const isAbTestAd = function (createChannel) {
  return createChannel && createChannel === 61
}
// 门店重构白名单
export function isInStoreWhite () {
  return Tool.isSupported(GLOBAL_VAR?.adver_func?.creative_update) && Tool.isSupported(GLOBAL_VAR?.adver_func?.landing_type_new_version_store)
}
// 门店重构：历史计划: !inventoryCatalog && 推广目的为门店
export function isStoreHistoryAd (curLandingType, inventoryCatalog) {
  return isInStoreWhite() && curLandingType === landingType.ADVERTISER_STORE.value && !inventoryCatalog
}
export function isOldShopAd (curLandingType, inventoryCatalog, deliveryMode) {
  return Tool.isSupported(GLOBAL_VAR?.adver_func?.landing_type_new_version_eshop) &&
    curLandingType === landingType.SHOP.value &&
    !inventoryCatalog &&
    deliveryMode !== CampaignState.deliveryMode.AUTO_DELIVERY.value // 管家不在禁用范围
}
